import type React from "react";
import { checkCompany } from "./CompanyName";

const company = JSON.parse(localStorage.getItem("company")!);

export const websiteBackOffice = {
  orderManagement: [
    {
      label: "View Detail",
      value: "view",
    },

    {
      label: "Edit Status",
      value: "edit",
    },
  ],
  specialRequest: [
    {
      label: "View Detail",
      value: "view",
    },
    {
      label: "Approve Order",
      value: "edit",
    },
  ],
  promotionSetting: [
    {
      label: "View Detail",
      value: "view",
    },
    {
      label: "Create Promotion",
      value: "create",
    },
    {
      label: "Edit Promotion",
      value: "edit",
    },
    {
      label: "Delete Promotion",
      value: "delete",
    },
    {
      label: "Download Excel",
      value: "excel",
    },
  ],
  detectOrder: [
    {
      label: "View Detail",
      value: "view",
    },
    {
      label: "Edit Promotion",
      value: "edit",
    },
  ],
  discountCo: [
    {
      label: "View Detail",
      value: "view",
    },
    {
      label: "Create Discount",
      value: "create",
    },
    {
      label: "Edit Discount",
      value: "edit",
    },
    {
      label: "Delete Discount",
      value: "delete",
    },
  ],
  priceListX10: [
    { label: "View Price List", value: "view" },
    {
      label: "Create Price List",
      value: "create",
    },
    {
      label: "Edit Price List",
      value: "edit",
    },
    {
      label: "Delete Price List",
      value: "delete",
    },
  ],
  saleManagement: [
    {
      label: "View Detail",
      value: "view",
    },
    {
      label: "Create User",
      value: "create",
    },
    {
      label: "Edit User",
      value: "edit",
    },
    {
      label: "Delete User",
      value: "delete",
    },
  ],
  roleManagement: [
    {
      label: "View Role",
      value: "view",
    },
    {
      label: "Create Role",
      value: "create",
    },
    {
      label: "Edit Role",
      value: "edit",
    },
    {
      label: "Delete Role",
      value: "delete",
    },
  ],
  productManagement: [
    {
      label: "View Product",
      value: "view",
    },
    {
      label: "Edit Product",
      value: "edit",
    },
  ],
  oneFinity: [
    {
      label: "View Setting",
      value: "view",
    },
    {
      label: "Edit Setting",
      value: "edit",
    },
  ],
  productBrandSetting: [
    {
      label: "Create Setting",
      value: "create",
    },
    {
      label: "Edit Setting",
      value: "edit",
    },
  ],
};

interface NestedList {
  label: string;
  value: string;
}

interface Group {
  groupNameNested?: string;
  listNested: NestedList[];
}

interface MainList {
  label?: string;
  value?: string;
  groupNameNested?: string;
  listNested?: NestedList[];
}

interface RoleGroup {
  isNested?: boolean;
  groupKey: string;
  groupName: string;
  list: (MainList | Group)[];
}

interface StaticRoles {
  [key: string]: RoleGroup;
}

export const staticRolesObject: StaticRoles = {
  report: {
    isNested: true,
    groupName: "รายงาน",
    groupKey: "REPORT",
    list: [
      {
        label: "โปรโมชัน",
        groupNameNested: "promotionReport",
        listNested: [
          {
            label: "ดูรายงานโปรโมชัน",
            value: "view",
          },
        ],
      },
      {
        label: "แคมเปญพอยน์",
        groupNameNested: "reportCampaignPoint",
        listNested: [
          {
            label: "ดูรายงานแคมเปญพอยน์",
            value: "view",
          },
        ],
      },
    ],
  },
  order: {
    isNested: true,
    groupName: "จัดการคำสั่งซื้อ",
    groupKey: "ORDER",
    list: [
      {
        label: "รายการคำสั่งซื้อ",
        groupNameNested: "orderList",
        listNested: [
          {
            label: "ดูคำสั่งซื้อ",
            value: "view",
          },
          {
            label: "แก้ไขสถานะคำสั่งซื้อ",
            value: "edit",
          },
          {
            label: "แสดงราคา",
            value: "showPrice",
          },
        ],
      },
      {
        label: "วงเงินร้านค้า",
        groupNameNested: "shopCreditLimit",
        listNested: [
          {
            label: "ดูรายการวงเงินร้านค้า",
            value: "view",
          },
        ],
      },
      {
        label: "ใบแจ้งหนี้/เอกสาร",
        groupNameNested: "invoiceList",
        listNested: [
          {
            label: "ดูใบแจ้งหนี้/เอกสาร",
            value: "view",
          },
          {
            label: "สร้างใบแจ้งหนี้/เอกสาร",
            value: "create",
          },
          {
            label: "แก้ไขใบแจ้งหนี้/เอกสาร",
            value: "edit",
          },
          {
            label: "ลบใบแจ้งหนี้/เอกสาร",
            value: "delete",
          },
        ],
      },
      {
        label: "เช็คคำขอวงเงิน",
        groupNameNested: "checkCreditLimit",
        listNested: [
          {
            label: "ดูรายการคำขอวงเงิน",
            value: "view",
          },
          {
            label: "ขอเพิ่มวงเงินชั่วคราว",
            value: "create",
          },
          {
            label: "แก้ไขวงเงินชั่วคราว",
            value: "edit",
          },
          {
            label: "ลบคำขอวงเงินชั่วคราว",
            value: "delete",
          },
        ],
      },
      // {
      //   label: "ตั้งค่าวงเงินเกิน",
      //   groupNameNested: "settingOverCredit",
      //   listNested: [
      //     {
      //       label: "ดูตั้งค่าวงเงินเกิน",
      //       value: "view",
      //     },
      //   ],
      // },
      {
        label: "กฎการอนุมัติวงเงิน",
        groupNameNested: "ruleAdvanceCreditLimit",
        listNested: [
          {
            label: "ดูกฎการอนุมัติวงเงิน",
            value: "view",
          },
          {
            label: "สร้างกฎการอนุมัติวงเงิน",
            value: "create",
          },
          {
            label: "แก้ไขกฎการอนุมัติวงเงิน",
            value: "edit",
          },
          {
            label: "ลบกฎการอนุมัติวงเงิน",
            value: "delete",
          },
        ],
      },
      {
        label: "ตั้งค่าวงเงินเกินรายร้าน",
        groupNameNested: "advanceCreditLimitEachShop",
        listNested: [
          {
            label: "ดูตั้งค่าวงเงินเกินรายร้าน",
            value: "view",
          },
          {
            label: "แก้ไขตั้งค่าวงเงินเกินรายร้าน",
            value: "edit",
          },
          {
            label: "ลบตั้งค่าวงเงินเกินรายร้าน",
            value: "delete",
          },
        ],
      },
      {
        label: "ตั้งค่าอนุมัติใบสั่งขาย",
        groupNameNested: "settingApproveSo",
        listNested: [
          {
            label: "ดูตั้งค่าใบสั่งขาย",
            value: "view",
          },
        ],
      },
    ],
  },
  specialRequest: {
    groupName: "อนุมัติคำสั่งซื้อ (Special Request)",
    groupKey: "SPREQ",
    list: [
      {
        label: "ดูคำสั่งซื้อ",
        value: "view",
      },
      {
        label: "อนุมัติ/ ยกเลิก คำสั่งซื้อ",
        value: "approve",
      },
    ],
  },
  receiveGoods: {
    groupName: "รายการรับสินค้า",
    groupKey: "RECEIVE",
    list: [
      {
        label: "ดูรายการรับสินค้า",
        value: "view",
      },
      {
        label: "ยกเลิกการรับสินค้า",
        value: "cancel",
      },
    ],
  },
  crm: {
    isNested: true,
    groupName: "crm",
    groupKey: "crm",
    list: [
      {
        label: "ระบบความสำเร็จ",
        groupNameNested: "achievement",
        listNested: [
          {
            label: "ดูระบบความสำเร็จ",
            value: "view",
          },
          {
            label: "สร้างระบบความสำเร็จ",
            value: "create",
          },
          {
            label: "แก้ไขระบบความสำเร็จ",
            value: "edit",
          },
          {
            label: "ลบระบบความสำเร็จ",
            value: "delete",
          },
          {
            label: "อนุมัติความสำเร็จ",
            value: "approve",
          },
        ],
      },
      {
        label: "แคมเปญพอยท์",
        groupNameNested: "campaignPoint",
        listNested: [
          {
            label: "ดูรายการแคมเปญ",
            value: "view",
          },
          {
            label: "สร้างแคมเปญ",
            value: "create",
          },
          {
            label: "ดูสถิติแคมเปญ",
            value: "report",
          },
          {
            label: "แก้ไขแคมเปญ",
            value: "edit",
          },
          {
            label: "ลบแคมเปญ",
            value: "delete",
          },
          {
            label: "อนุมัติแคมเปญ",
            value: "approve",
          },
        ],
      },
      {
        label: "รายงานรายร้าน",
        groupNameNested: "customerPointReport",
        listNested: [
          {
            label: "ดูรายงาน",
            value: "view",
          },
        ],
      },
      {
        label: "รายการอนุมัติแต้ม",
        groupNameNested: "approvePointList",
        listNested: [
          {
            label: "ดูรายงาน",
            value: "view",
          },
        ],
      },
    ],
  },
  productList: {
    isNested: true,
    groupName: "จัดการสินค้า",
    groupKey: "PROD",
    list: [
      {
        label: "รายการสินค้า",
        groupNameNested: "productList",
        listNested: [
          {
            label: "ดูสินค้า",
            value: "view",
          },
          {
            label: "แก้ไขสินค้า",
            value: "edit",
          },
          {
            label: "เชื่อมต่อ Navision",
            value: "sync",
          },
        ],
      },
      {
        label: "ราคาสินค้าเฉพาะร้าน",
        groupNameNested: "priceSpecialExclusive",
        listNested: [
          {
            label: "ดูราคาสินค้า",
            value: "view",
          },
          {
            label: "สร้างสินค้า",
            value: "create",
          },
          {
            label: "แก้ไขสินค้า",
            value: "edit",
          },
        ],
      },
      {
        label: "สินค้าขายเฉพาะร้าน",
        groupNameNested: "productShop",
        listNested: [
          {
            label: "ดูสินค้า",
            value: "view",
          },
          {
            label: "แก้ไขสินค้า",
            value: "edit",
          },
        ],
      },
    ],
  },
  promotionSetting: {
    isNested: true,
    groupName: "โปรโมชั่น",
    groupKey: "PROMOTION",
    list: [
      {
        label: "ตั้งค่าโปรโมชั่น",
        groupNameNested: "promotion",
        listNested: [
          {
            label: "ดูโปรโมชั่น",
            value: "view",
          },
          {
            label: "สร้างโปรโมชั่น",
            value: "create",
          },
          {
            label: "แก้ไขโปรโมชั่น",
            value: "edit",
          },
          {
            label: "ลบโปรโมชั่น",
            value: "delete",
          },
          {
            label: "อนุมัติโปรโมชั่น",
            value: "approve",
          },
          {
            label: "ดาวน์โหลด Excel",
            value: "excel",
          },
        ],
      },
      {
        label: "แจ้งเตือนโปรโมชั่น",
        groupNameNested: "promotionNoti",
        listNested: [
          {
            label: "ดูการแจ้งเตือน",
            value: "view",
          },
          {
            label: "สร้างการแจ้งเตือน",
            value: "create",
          },
          {
            label: "แก้ไขการแจ้งเตือน",
            value: "edit",
          },
          {
            label: "ลบการแจ้งเตือน",
            value: "delete",
          },
        ],
      },
      {
        label: "ตั้งค่า Flash Sale",
        groupNameNested: "flashSale",
        listNested: [
          {
            label: "ดูการตั้งค่า Flash Sale",
            value: "view",
          },
          {
            label: "สร้างการตั้งค่า Flash Sale",
            value: "create",
          },
          {
            label: "แก้ไขการตั้งค่า Flash Sale",
            value: "edit",
          },
          {
            label: "ลบการตั้งค่า Flash Sale",
            value: "delete",
          },
          {
            label: "ดาวน์โหลด Excel",
            value: "excel",
          },
          {
            label: "อนุมัติ Flash Sale",
            value: "approve",
          },
        ],
      },
    ],
  },
  productQuota: {
    groupName: "กำหนดโควตาสินค้า",
    groupKey: "PRODUCT_QUOTA",
    list: [
      {
        label: "ดูโควตาสินค้า",
        value: "view",
      },
      {
        label: "สร้างโควตาสินค้า",
        value: "create",
      },
      {
        label: "แก้ไขโควตาสินค้า",
        value: "edit",
      },
      {
        label: "ลบโควตาสินค้า",
        value: "delete",
      },
    ],
  },
  detectOrder: {
    isNested: true,
    groupName: "ตรวจจับยอดสั่งซื้อ",
    groupKey: "DETECTION",
    list: [
      {
        label: "รายการตรวจจับ",
        groupNameNested: "detectionList",
        listNested: [
          {
            label: "ดูรายการตรวจจับ",
            value: "view",
          },
          {
            label: "แก้ไขรายการตรวจจับ",
            value: "edit",
          },
        ],
      },
      {
        label: "ตั้งค่าสต๊อกร้านค้า",
        groupNameNested: "stockSetting",
        listNested: [
          {
            label: "ดูตั้งค่าสต๊อกร้านค้า",
            value: "view",
          },
          {
            label: "แก้ไขตั้งค่าสต๊อกร้านค้า",
            value: "edit",
          },
        ],
      },
      {
        label: "ตั้งค่าเกณฑ์ตรวจจับ",
        groupNameNested: "thresholdSetting",
        listNested: [
          {
            label: "ดูเกณฑ์ตรวจจับ",
            value: "view",
          },
          {
            label: "แก้ไขเกณฑ์ตรวจจับ",
            value: "edit",
          },
        ],
      },
    ],
  },
  freebieList: {
    groupName: "รายการของแถม",
    groupKey: "FREEB",
    list: [
      {
        label: "ดูรายการของแถม",
        value: "view",
      },
      {
        label: "แก้ไขของแถม",
        value: "edit",
      },
      {
        label: "เชื่อมต่อ Navision",
        value: "sync",
      },
    ],
  },
  DOReport: {
    groupName: "รายการเตรียมจัดส่ง",
    groupKey: "DOREPORT",
    list: [
      {
        label: "ดูรายการเตรียมจัดส่ง",
        value: "view",
      },
    ],
  },
  shopTier: {
    groupName: "ระดับร้านค้า",
    groupKey: "SHOP_TIER",
    list: [
      {
        label: "ดูระดับร้านค้า",
        value: "view",
      },
      {
        label: "สร้างระดับร้านค้า",
        value: "create",
      },
      {
        label: "แก้ไขระดับร้านค้า",
        value: "edit",
      },
      {
        label: "ดาวน์โหลด Excel",
        value: "excel",
      },
    ],
  },
  discountCo: {
    isNested: true,
    groupName: "ส่วนลดดูแลราคา",
    groupKey: "DISCO",
    list: [
      {
        label: "รายการส่วนลด",
        groupNameNested: "discountList",
        listNested: [
          {
            label: "ดูรายการส่วนลด",
            value: "view",
          },
          {
            label: "สร้างรายการส่วนลด",
            value: "create",
          },
          {
            label: "แก้ไขรายการส่วนลด",
            value: "edit",
          },
          {
            label: "ลบรายการส่วนลด",
            value: "delete",
          },
          {
            label: "อนุมัติรายการส่วนลด",
            value: "approve",
          },
        ],
      },
      {
        label: "ส่วนลดดูแลราคารายร้าน",
        groupNameNested: "manageConditionStore",
        listNested: [
          {
            label: "ดูส่วนลดดูแลราคารายร้าน",
            value: "view",
          },
          {
            label: "สร้างส่วนลดดูแลราคารายร้าน",
            value: "create",
          },
          {
            label: "แก้ไขส่วนลดดูแลราคารายร้าน",
            value: "edit",
          },
          {
            label: "ลบส่วนลดดูแลราคารายร้าน",
            value: "delete",
          },
          {
            label: "ดาวน์โหลด Excel",
            value: "excel",
          },
        ],
      },
      {
        groupNameNested: "manageCondition",
        label: "จัดการเงื่อนไขดูแลราคา",
        listNested: [
          {
            label: "ดูจัดการเงื่อนไขดูแลราคา",
            value: "view",
          },
          {
            label: "สร้างจัดการเงื่อนไขดูแลราคา",
            value: "create",
          },
          {
            label: "แก้ไขจัดการเงื่อนไขดูแลราคา",
            value: "edit",
          },
          {
            label: "ลบจัดการเงื่อนไขดูแลราคา",
            value: "delete",
          },
          {
            label: "อนุมัติจัดการเงื่อนไขดูแลราคา",
            value: "approve",
          },
        ],
      },
    ],
  },
  newDiscountCo: {
    isNested: true,
    groupName: "ส่วนลดดูแลราคา (ใหม่)",
    groupKey: "DISCONEW",
    list: [
      {
        groupNameNested: "coDiscountDashboard",
        label: "CO Dashboard",
        listNested: [
          {
            label: "ดูข้อมูลแดชบอร์ด",
            value: "view",
          },
          {
            label: "ดาวน์โหลด Excel",
            value: "excel",
          },
        ],
      },
      {
        groupNameNested: "coDiscountList",
        label: "ส่วนลดทั้งหมด",
        listNested: [
          {
            label: "ดูส่วนลดทั้งหมด",
            value: "view",
          },
          {
            label: "สร้างส่วนลดทั้งหมด",
            value: "create",
          },
          {
            label: "แก้ไขส่วนลดทั้งหมด",
            value: "edit",
          },
          {
            label: "ลบส่วนลดทั้งหมด",
            value: "delete",
          },
          {
            label: "ดาวน์โหลด Excel",
            value: "excel",
          },
        ],
      },
      {
        groupNameNested: "coDiscountEachShop",
        label: "ส่วนลดรายร้าน",
        listNested: [
          {
            label: "ดูส่วนลดรายร้าน",
            value: "view",
          },
          {
            label: "สร้างส่วนลดรายร้าน",
            value: "create",
          },
          {
            label: "แก้ไขส่วนลดรายร้าน",
            value: "edit",
          },
          {
            label: "ดาวน์โหลด Excel",
            value: "excel",
          },
        ],
      },
      {
        groupNameNested: "coDiscountType",
        label: "ประเภทส่วนลด CO",
        listNested: [
          {
            label: "ดูประเภทส่วนลด CO",
            value: "view",
          },
          {
            label: "สร้างประเภทส่วนลด CO",
            value: "create",
          },
          {
            label: "แก้ไขประเภทส่วนลด CO",
            value: "edit",
          },
          {
            label: "ลบประเภทส่วนลด CO",
            value: "delete",
          },
        ],
      },
    ],
  },
  news: {
    isNested: true,
    groupName: "ข่าวสาร",
    groupKey: "NEWS",
    list: [
      {
        label: "รายการข่าวสาร",
        groupNameNested: "newsList",
        listNested: [
          {
            label: "สร้างรายการข่าวสาร",
            value: "create",
          },
          {
            label: "แก้ไขรายการข่าวสาร",
            value: "edit",
          },
          {
            label: "ลบรายการข่าวสาร",
            value: "delete",
          },
        ],
      },
      {
        label: "ปักหมุดข่าวสาร",
        groupNameNested: "pinedNews",
        listNested: [
          {
            label: "แก้ไขปักหมุดข่าวสาร",
            value: "edit",
          },
        ],
      },
      {
        groupNameNested: "highlightNews",
        label: "ข่าวสารไฮไลท์",
        listNested: [
          {
            label: "สร้างข่าวสารไฮไลท์",
            value: "create",
          },
          {
            label: "แก้ไขข่าวสารไฮไลท์",
            value: "edit",
          },
          {
            label: "ลบข่าวสารไฮไลท์",
            value: "delete",
          },
        ],
      },
    ],
  },
};
export const staticRolesSaleApp: StaticRoles = {
  order: {
    groupName: "เมนูสั่งสินค้า",
    groupKey: "ORDER",
    list: [
      {
        label: "ดูเมนูสั่งสินค้า",
        value: "view",
      },
    ],
  },
  history: {
    groupName: "เมนูประวัติ",
    groupKey: "HISTORT",
    list: [
      {
        label: "ดูเมนูประวัติ",
        value: "view",
      },
    ],
  },
  receiveGoods: {
    groupName: "เมนูร้านรับสินค้า",
    groupKey: "RECEIVE",
    list: [
      {
        label: "ดูเมนูร้านรับสินค้า",
        value: "view",
      },
    ],
  },
  confirmSpecialPro: {
    groupName: "เมนูอนุมัติคำสั่งซื้อ",
    groupKey: "SPECIALPRO",
    list: [
      {
        label: "ดูเมนูอนุมัติคำสั่งซื้อ",
        value: "view",
      },
    ],
  },
  creditLimit: {
    groupName: "เมนูอนุมัติวงเงินเกิน",
    groupKey: "CREDITLIMIT",
    list: [
      {
        label: "ดูรายการ",
        value: "view",
      },
      {
        label: "จัดการรายการคำขอ",
        value: "manage",
      },
      {
        label: "อนุมัติ / ปฏิเสธคำขอ",
        value: "approve",
      },
    ],
  },
  saleOrder: {
    groupName: "เมนูอนุมัติใบสั่งขาย",
    groupKey: "SALEORDER",
    list: [
      {
        label: "ดูเมนูอนุมัติใบสั่งขาย",
        value: "view",
      },
    ],
  },
  creditShop: {
    groupName: "วงเงินร้านค้า",
    groupKey: "CREDIT_SHOP",
    list: [
      {
        label: "ดูเมนูวงเงินร้านค้า",
        value: "view",
      },
    ],
  },
  orderTrack: {
    groupName: "ติดตามสินค้า",
    groupKey: "ORDER_TRACK",
    list: [
      {
        label: "ดูเมนูติดตามสินค้า",
        value: "view",
      },
    ],
  },
  discountCO: {
    groupName: "ส่วนลด CO",
    groupKey: "DISCOUNT_CO",
    list: [
      {
        label: "ดูเมนูส่วนลด CO",
        value: "view",
      },
    ],
  },
  shopTier: {
    groupName: "ระดับร้านค้า",
    groupKey: "SHOP_TIER",
    list: [
      {
        label: "ดูเมนูระดับร้านค้า",
        value: "view",
      },
    ],
  },
};
export const staticManageRoles: StaticRoles = {
  // Manage
  manageUser: {
    isNested: true,
    groupName: "จัดการผู้ใช้งาน",
    groupKey: "USER",
    list: [
      {
        label: "รายชื่อผู้ใช้งาน",
        groupNameNested: "userList",
        listNested: [
          {
            label: "ดูรายชื่อผู้ใช้งาน",
            value: "view",
          },
          {
            label: "เพิ่มผู้ใช้งาน",
            value: "create",
          },
          {
            label: "แก้ไขผู้ใช้งาน",
            value: "edit",
          },
          {
            label: "ลบผู้ใช้งาน",
            value: "delete",
          },
        ],
      },
      {
        label: "จัดการบทบาท",
        groupNameNested: "manageRoles",
        listNested: [
          {
            label: "ดูรายการบทบาทผู้ใช้งาน",
            value: "view",
          },
          {
            label: "เพิ่มบทบาทผู้ใช้งาน",
            value: "create",
          },
          {
            label: "แก้ไขบทบาทผู้ใช้งาน",
            value: "edit",
          },
          {
            label: "ลบบทบาทผู้ใช้งาน",
            value: "delete",
          },
        ],
      },
    ],
  },
  manageStore: {
    isNested: true,
    groupName: "จัดการร้านค้า",
    groupKey: "STORE",
    list: [
      // {
      //   label: "รายชื่อร้านค้า",
      //   groupNameNested: "storeList",
      //   listNested: [
      //     {
      //       label: "ดูรายชื่อร้านค้า",
      //       value: "view",
      //     },
      //     {
      //       label: "สร้างร้านค้า",
      //       value: "create",
      //     },
      //     {
      //       label: "แก้ไขร้านค้า",
      //       value: "edit",
      //     },
      //     {
      //       label: "เชื่อมต่อ Navision",
      //       value: "sync",
      //     },
      //   ],
      // }, รายชื่อร้านค้า ver. เก่า
      {
        label: "รายชื่อร้านค้า",
        groupNameNested: "corporateShop",
        listNested: [
          {
            label: "ดูรายชื่อร้านค้า",
            value: "view",
          },
          {
            label: "แก้ไขร้านค้า",
            value: "edit",
          },
          {
            label: "จัดการผู้ใช้งานลูกค้า",
            value: "manageUser",
          },
          {
            label: "อัปเดตร้านค้าใหม่",
            value: "sync",
          },
          {
            label: "เพิ่ม Sub-Dealer",
            value: "subdealer",
          },
        ],
      },
      {
        label: "จัดกลุ่มร้านค้า",
        groupNameNested: "shopGroup",
        listNested: [
          {
            label: "ดูกลุ่มร้านค้า",
            value: "view",
          },
          {
            label: "สร้างกลุ่มร้านค้า",
            value: "create",
          },
          {
            label: "แก้ไขกลุ่มร้านค้า",
            value: "edit",
          },
        ],
      },
      {
        label: "อนุมัติเบอร์โทรศัพท์",
        groupNameNested: "approvePhone",
        listNested: [
          {
            label: "ดูรายการอนุมัติ",
            value: "view",
          },
          {
            label: "อนุมัติการเปลี่ยนเบอร์มือถือร้านค้า",
            value: "approve",
          },
        ],
      },
    ],
  },
  // shopTier: {
  //   groupName: "ระดับร้านค้า",
  //   groupKey: "SHOP_TIER",
  //   list: [
  //     {
  //       label: "ดูเมนูระดับร้านค้า",
  //       value: "view",
  //     },
  //     {
  //       label: "แก้ไขสิทธิประโยชน์",
  //       value: "edit",
  //     },
  //     {
  //       label: "ดาวน์โหลด Excel",
  //       value: "excel",
  //     },
  //   ],
  // },
  generalSettings: {
    isNested: true,
    groupName: "ตั้งค่า",
    groupKey: "GENERALSETTING", //generalSettings
    list: checkCompany(company?.companyCode)
      ? [
          {
            label: "แบรนด์สินค้า",
            groupNameNested: "productBrandSetting",
            listNested: [
              {
                label: "สร้างแบรนด์สินค้า",
                value: "create",
              },
              {
                label: "แก้ไขแบรนด์สินค้า",
                value: "edit",
              },
            ],
          },
          {
            label: "กลุ่มสินค้า",
            groupNameNested: "productGroup",
            listNested: [
              {
                label: "สร้างกลุ่มสินค้า",
                value: "create",
              },
              {
                label: "แก้ไขกลุ่มสินค้า",
                value: "edit",
              },
            ],
          },
          {
            label: "หมวดสินค้า",
            groupNameNested: "prodCategory",
            listNested: [
              {
                label: "สร้างหมวดสินค้า",
                value: "create",
              },
              {
                label: "แก้ไขหมวดสินค้า",
                value: "edit",
              },
            ],
          },
          {
            label: "ทีม",
            groupNameNested: "teamSetting",
            listNested: [
              {
                label: "สร้างทีม",
                value: "create",
              },
              {
                label: "แก้ไขทีม",
                value: "edit",
              },
            ],
          },
          {
            label: "เขต",
            groupNameNested: "zoneSetting",
            listNested: [
              {
                label: "สร้างเขต",
                value: "create",
              },
              {
                label: "แก้ไขเขต",
                value: "edit",
              },
            ],
          },
        ]
      : [
          {
            label: "แบรนด์สินค้า",
            groupNameNested: "productBrandSetting",
            listNested: [
              {
                label: "สร้างแบรนด์สินค้า",
                value: "create",
              },
              {
                label: "แก้ไขแบรนด์สินค้า",
                value: "edit",
              },
            ],
          },
          {
            label: "กลุ่มสินค้า",
            groupNameNested: "productGroup",
            listNested: [
              {
                label: "สร้างกลุ่มสินค้า",
                value: "create",
              },
              {
                label: "แก้ไขกลุ่มสินค้า",
                value: "edit",
              },
            ],
          },
          {
            label: "หมวดสินค้า",
            groupNameNested: "prodCategory",
            listNested: [
              {
                label: "สร้างหมวดสินค้า",
                value: "create",
              },
              {
                label: "แก้ไขหมวดสินค้า",
                value: "edit",
              },
            ],
          },
          {
            label: "ทีม",
            groupNameNested: "teamSetting",
            listNested: [
              {
                label: "สร้างทีม",
                value: "create",
              },
              {
                label: "แก้ไขทีม",
                value: "edit",
              },
            ],
          },
          {
            label: "เขต",
            groupNameNested: "zoneSetting",
            listNested: [
              {
                label: "สร้างเขต",
                value: "create",
              },
              {
                label: "แก้ไขเขต",
                value: "edit",
              },
            ],
          },
          {
            label: "โรงงาน",
            groupNameNested: "factorySetting",
            listNested: [
              {
                label: "สร้างโรงงาน",
                value: "create",
              },
              {
                label: "แก้ไขโรงงาน",
                value: "edit",
              },
            ],
          },
          {
            label: "หน่วยสินค้า",
            groupNameNested: "unitSetting",
            listNested: [
              {
                label: "สร้างหน่วยสินค้า",
                value: "create",
              },
              {
                label: "แก้ไขหน่วยสินค้า",
                value: "edit",
              },
            ],
          },
          {
            label: "เวลาเปิด/ปิดคำสั่งซื้อ",
            groupNameNested: "timeOrderSetting",
            listNested: [
              {
                label: "ดูเวลาเปิด/ปิดคำสั่งซื้อ",
                value: "view",
              },
              {
                label: "สร้างเวลาเปิด/ปิดคำสั่งซื้อ",
                value: "create",
              },
              {
                label: "แก้ไขเวลาเปิด/ปิดคำสั่งซื้อ",
                value: "edit",
              },
              {
                label: "แก้ไขเวลาเปิด/ปิดคำสั่งซื้อ",
                value: "delete",
              },
            ],
          },
        ],
  },
};
export const mockRoles = [
  {
    menuName: "report",
    menu: {
      promotionReport: ["view"],
      reportCampaignPoint: ["view"],
    },
  },
  {
    menuName: "order",
    menu: {
      orderList: ["view", "edit", "showPrice"],
      shopCreditLimit: ["view"],
      checkCreditLimit: ["view", "create", "edit", "delete"],
      // settingOverCredit: ["view"],
      ruleAdvanceCreditLimit: ["view", "create", "edit", "delete"],
      advanceCreditLimitEachShop: ["view", "edit", "delete"],
      settingApproveSo: ["view"],
      invoiceList: ["view", "create", "edit", "delete"],
    },
  },
  {
    menuName: "specialRequest",
    menu: ["view", "approve"],
  },
  {
    menuName: "receiveGoods",
    menu: ["view", "cancel"],
  },
  {
    menuName: "productQuota",
    menu: ["view", "create", "edit", "delete"],
  },
  {
    menuName: "productList",
    menu: {
      productList: ["view", "edit", "sync"],
      priceSpecialExclusive: ["view", "create", "edit", "delete"],
      productShop: ["view", "edit"],
    },
  },
  {
    menuName: "promotionSetting",
    menu: {
      promotion: ["create", "view", "edit", "delete", "approve", "excel"],
      promotionNoti: ["create", "view", "edit", "delete"],
      flashSale: ["create", "view", "edit", "delete", "approve", "excel"],
    },
  },
  {
    menuName: "detectOrder",
    menu: {
      detectionList: ["view", "edit"],
      stockSetting: ["view", "edit"],
      thresholdSetting: ["create", "view", "edit", "delete", "approve"],
    },
  },
  {
    menuName: "freebieList",
    menu: ["view", "edit", "sync"],
  },
  {
    menuName: "discountCo",
    menu: {
      coDiscountDashboard: ["view", "excel"],
      discountList: ["create", "view", "edit", "delete", "approve"],
      manageConditionStore: ["create", "view", "edit", "delete", "approve", "excel"],
      manageCondition: ["create", "view", "edit"],
    },
  },
  {
    menuName: "newDiscountCo",
    menu: {
      coDiscountList: ["create", "view", "edit", "delete", "excel"],
      coDiscountEachShop: ["create", "view", "edit", "excel"],
      coDiscountType: ["create", "view", "edit", "delete"],
    },
  },
  {
    menuName: "news",
    menu: {
      newsList: ["create", "edit", "delete"],
      pinedNews: ["edit"],
      highlightNews: ["create", "edit", "delete"],
    },
  },
  {
    menuName: "manageUser",
    menu: {
      userList: ["view", "create", "edit", "delete"],
      manageRoles: ["view", "create", "edit", "delete"],
    },
  },
  {
    menuName: "manageStore",
    menu: {
      storeList: ["view", "create", "edit", "sync"],
      approvePhone: ["view", "approve"],
      shopGroup: ["view", "create", "edit"],
      corporateShop: ["view", "edit", "manageUser", "sync", "subdealer"],
    },
  },
  {
    menuName: "shopTier",
    menu: ["view", "edit", "excel"],
  },
  {
    menuName: "generalSettings",
    menu: {
      productBrandSetting: ["create", "edit"],
      productGroup: ["create", "edit"],
      prodCategory: ["create", "edit"],
      teamSetting: ["create", "edit"],
      zoneSetting: ["create", "edit"],
      factorySetting: ["create", "edit"],
      unitSetting: ["create", "edit"],
      timeOrderSetting: ["view", "create", "edit", "delete"],
    },
  },
  {
    menuName: "crm",
    menu: {
      campaignPoint: ["view", "create", "edit", "approve", "report", "delete"],
      customerPointReport: ["view"],
      approvePointList: ["view"],
      achievement: ["view", "create", "edit", "approve", "delete"],
    },
  },
  {
    menuName: "DOReport",
    menu: ["view"],
  },
];
